import { CSSObject } from "@mui/material";
import { appStyles } from "./appStyles";
import _ from "lodash";

const gridColumnSpan: CSSObject = _.range(12).reduce((acc: CSSObject, i) => {
    acc[`.span-${i + 1}`] = {
        gridColumn: `span ${i + 1}`,
    };
    return acc;
}, {});

const globals: CSSObject = {
    ".grecaptcha-badge": {
        visibility: "hidden",
    },
    "& .flex-item": {
        flex: "1 1 auto",
    },
    "& .flex-center-content": {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
    },
    '& a': {
        fontWeight: 500,
        '&:link': {
            color: appStyles.accentColor.backgroundMain,
            textDecoration: 'none',
        },
        '&:visited': {
            color: appStyles.accentColor.backgroundMain,
            textDecoration: 'none',
        },
        '&:hover': {
            color: appStyles.accentColor.backgroundHover,
            textDecoration: 'underline',
        },
    },
    ...gridColumnSpan,
};

export default globals;
